import { render, staticRenderFns } from "./FrmNewEvent.vue?vue&type=template&id=fa7f4192"
import script from "./FrmNewEvent.vue?vue&type=script&lang=js"
export * from "./FrmNewEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports